import api from './api';

export interface FooterSettings {
  contact_address?: string;
  contact_phone?: string;
  contact_email?: string;
  social_facebook?: string;
  social_instagram?: string;
  social_tiktok?: string;
  social_youtube?: string;
  copyright_text?: string;
  developed_by?: string;
}

class FooterService {
  // Obtener todas las configuraciones del footer
  async getFooterSettings(): Promise<FooterSettings> {
    try {
      const response = await api.get('/footer');
      return response.data || {};
    } catch (error) {
      console.error('Error al obtener configuraciones del footer:', error);
      throw error;
    }
  }

  // Actualizar todas las configuraciones del footer
  async updateFooterSettings(settings: FooterSettings): Promise<{ message: string }> {
    try {
      const response = await api.put('/footer', settings);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar configuraciones del footer:', error);
      throw error;
    }
  }

  // Obtener una configuración específica del footer
  async getFooterSetting(key: string): Promise<{ key: string; value: string }> {
    try {
      const response = await api.get(`/footer/${key}`);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener configuración ${key} del footer:`, error);
      throw error;
    }
  }

  // Actualizar una configuración específica del footer
  async updateFooterSetting(key: string, value: string): Promise<{ message: string; setting: any }> {
    try {
      const response = await api.put(`/footer/${key}`, { value });
      return response.data;
    } catch (error) {
      console.error(`Error al actualizar configuración ${key} del footer:`, error);
      throw error;
    }
  }
}

export const footerService = new FooterService();
export default footerService;